import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
============
== POTREE ==
============

http://potree.org

Copyright (c) 2011-2020, Markus Schütz
All rights reserved.

    Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

    1. Redistributions of source code must retain the above copyright notice, this
list of conditions and the following disclaimer.
2. Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

    The views and conclusions contained in the software and documentation are those
of the authors and should not be interpreted as representing official policies,
    either expressed or implied, of the FreeBSD Project.
 */
import { PointAttribute, PointAttributeTypes } from "../Core/Potree2PointAttributes";
var typedArrayMapping = {
  int8: Int8Array,
  int16: Int16Array,
  int32: Int32Array,
  int64: Float64Array,
  uint8: Uint8Array,
  uint16: Uint16Array,
  uint32: Uint32Array,
  uint64: Float64Array,
  "float": Float32Array,
  "double": Float64Array
};

onmessage = function (event) {
  var _event$data = event.data,
      buffer = _event$data.buffer,
      pointAttributes = _event$data.pointAttributes,
      scale = _event$data.scale,
      min = _event$data.min,
      size = _event$data.size,
      offset = _event$data.offset,
      numPoints = _event$data.numPoints;
  var view = new DataView(buffer);
  var attributeBuffers = {};
  var attributeOffset = 0;
  var bytesPerPoint = 0;

  var _iterator = _createForOfIteratorHelper(pointAttributes.attributes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pointAttribute = _step.value;
      bytesPerPoint += pointAttribute.byteSize;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var gridSize = 32;
  var grid = new Uint32Array(Math.pow(gridSize, 3));

  var toIndex = function (x, y, z) {
    // min is already subtracted
    var dx = gridSize * x / size.x;
    var dy = gridSize * y / size.y;
    var dz = gridSize * z / size.z;
    var ix = Math.min(parseInt(dx, 10), gridSize - 1);
    var iy = Math.min(parseInt(dy, 10), gridSize - 1);
    var iz = Math.min(parseInt(dz, 10), gridSize - 1);
    return ix + iy * gridSize + iz * gridSize * gridSize;
  };

  var numOccupiedCells = 0;

  var _iterator2 = _createForOfIteratorHelper(pointAttributes.attributes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _pointAttribute = _step2.value;

      if (['POSITION_CARTESIAN', 'position'].includes(_pointAttribute.name)) {
        var _buff = new ArrayBuffer(numPoints * 4 * 3);

        var positions = new Float32Array(_buff);

        for (var _j = 0; _j < numPoints; _j++) {
          var pointOffset = _j * bytesPerPoint;
          var x = view.getInt32(pointOffset + attributeOffset + 0, true) * scale[0] + offset[0] - min.x;
          var y = view.getInt32(pointOffset + attributeOffset + 4, true) * scale[1] + offset[1] - min.y;
          var z = view.getInt32(pointOffset + attributeOffset + 8, true) * scale[2] + offset[2] - min.z;
          var index = toIndex(x, y, z);
          var count = grid[index]++;

          if (count === 0) {
            numOccupiedCells++;
          }

          positions[3 * _j + 0] = x;
          positions[3 * _j + 1] = y;
          positions[3 * _j + 2] = z;
        }

        attributeBuffers[_pointAttribute.name] = {
          buffer: _buff,
          attribute: _pointAttribute
        };
      } else if (['RGBA', 'rgba'].includes(_pointAttribute.name)) {
        var _buff2 = new ArrayBuffer(numPoints * 4);

        var colors = new Uint8Array(_buff2);

        for (var _j2 = 0; _j2 < numPoints; _j2++) {
          var _pointOffset = _j2 * bytesPerPoint;

          var r = view.getUint16(_pointOffset + attributeOffset + 0, true);
          var g = view.getUint16(_pointOffset + attributeOffset + 2, true);
          var b = view.getUint16(_pointOffset + attributeOffset + 4, true);
          colors[4 * _j2 + 0] = r > 255 ? r / 256 : r;
          colors[4 * _j2 + 1] = g > 255 ? g / 256 : g;
          colors[4 * _j2 + 2] = b > 255 ? b / 256 : b;
        }

        attributeBuffers[_pointAttribute.name] = {
          buffer: _buff2,
          attribute: _pointAttribute
        };
      } else {
        var _buff3 = new ArrayBuffer(numPoints * 4);

        var _f = new Float32Array(_buff3);

        var TypedArray = typedArrayMapping[_pointAttribute.type.name];
        var preciseBuffer = new TypedArray(numPoints);
        var _offset2 = 0,
            _scale2 = 1;
        var getterMap = {
          int8: view.getInt8,
          int16: view.getInt16,
          int32: view.getInt32,
          uint8: view.getUint8,
          uint16: view.getUint16,
          uint32: view.getUint32,
          "float": view.getFloat32,
          "double": view.getFloat64
        };

        var _getter = getterMap[_pointAttribute.type.name].bind(view); // compute offset and scale to pack larger types into 32 bit floats


        if (_pointAttribute.type.size > 4) {
          var _pointAttribute$range = _slicedToArray(_pointAttribute.range, 2),
              amin = _pointAttribute$range[0],
              amax = _pointAttribute$range[1];

          _offset2 = amin;
          _scale2 = 1 / (amax - amin);
        }

        for (var _j3 = 0; _j3 < numPoints; _j3++) {
          var _pointOffset2 = _j3 * bytesPerPoint;

          var _value = _getter(_pointOffset2 + attributeOffset, true);

          _f[_j3] = (_value - _offset2) * _scale2;
          preciseBuffer[_j3] = _value;
        }

        attributeBuffers[_pointAttribute.name] = {
          buffer: _buff3,
          preciseBuffer: preciseBuffer,
          attribute: _pointAttribute,
          offset: _offset2,
          scale: _scale2
        };
      }

      attributeOffset += _pointAttribute.byteSize;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var occupancy = parseInt(numPoints / numOccupiedCells, 10);
  {
    // add indices
    var buff = new ArrayBuffer(numPoints * 4);
    var indices = new Uint32Array(buff);

    for (var i = 0; i < numPoints; i++) {
      indices[i] = i;
    }

    attributeBuffers.INDICES = {
      buffer: buff,
      attribute: PointAttribute.INDICES
    };
  }
  {
    // handle attribute vectors
    var vectors = pointAttributes.vectors;

    var _iterator3 = _createForOfIteratorHelper(vectors),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var vector = _step3.value;
        var name = vector.name,
            attributes = vector.attributes;
        var numVectorElements = attributes.length;

        var _buffer = new ArrayBuffer(numVectorElements * numPoints * 4);

        var f32 = new Float32Array(_buffer);
        var iElement = 0;

        var _iterator4 = _createForOfIteratorHelper(attributes),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var sourceName = _step4.value;
            var sourceBuffer = attributeBuffers[sourceName];
            var _offset = sourceBuffer.offset,
                _scale = sourceBuffer.scale;

            var _view = new DataView(sourceBuffer.buffer);

            var getter = _view.getFloat32.bind(_view);

            for (var j = 0; j < numPoints; j++) {
              var value = getter(j * 4, true);
              f32[j * numVectorElements + iElement] = value / _scale + _offset;
            }

            iElement++;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        var vecAttribute = new PointAttribute(name, PointAttributeTypes.DATA_TYPE_FLOAT, 3);
        attributeBuffers[name] = {
          buffer: _buffer,
          attribute: vecAttribute
        };
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  var message = {
    buffer: buffer,
    attributeBuffers: attributeBuffers,
    density: occupancy
  };
  var transferables = [];
  Object.keys(message.attributeBuffers).forEach(function (property) {
    transferables.push(message.attributeBuffers[property].buffer);
  });
  transferables.push(buffer);
  postMessage(message, transferables);
};